import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, TrendingDown, DollarSign, HelpCircle } from 'lucide-react';
const problems = [{
  icon: TrendingDown,
  text: 'Moto sin potencia'
}, {
  icon: AlertCircle,
  text: 'Fallas constantes'
}, {
  icon: DollarSign,
  text: 'Gastos innecesarios'
}, {
  icon: HelpCircle,
  text: 'No sabés qué está fallando'
}];
export function ProblemSection() {
  return <section className="w-full bg-gradient-to-b from-motor-black to-gray-900 py-14 px-4 sm:px-6 lg:px-8" data-id="element-150">
      <div className="max-w-5xl mx-auto" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-152">
          <h2 className="font-bebas text-4xl sm:text-5xl lg:text-6xl text-white uppercase mb-4" data-id="element-153">
            Si tu moto pierde fuerza, falla o te hace gastar plata…{' '}
            <span className="text-motor-red" data-id="element-154">no sos el único</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-155">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-gray-800/50 border border-motor-red/30 p-4 rounded-lg backdrop-blur-sm hover:border-motor-red/60 transition-all duration-300" data-id="element-156">
              <problem.icon className="w-10 h-10 text-motor-red mb-3" data-id="element-157" />
              <p className="font-montserrat font-semibold text-white text-base" data-id="element-158">
                {problem.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}